import StepTwo from "@/components/dashboard/pay/StepTwo";

export default function PayStepTwo() {
  return <StepTwo />;
}
